<template>
  <div class="add-link">
    <AddLink/>
  </div>
</template>

<script>
// @ is an alias to /src
import AddLink from '@/components/AddLink.vue'

export default {
  name: 'AddLinkPage',
  components: {
    AddLink
  }
}
</script>
